import React from 'react';
import { useSelector } from 'react-redux';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { getBundleType } from '../../selectors/filtersSelectors';
import NonStopCheckbox from './NonStopCheckbox/NonStopCheckbox';
import { BUNDLE_TYPES } from '../../constants/packagesConstants';
import CountryOfResidenceDropdown from './CountryOfResidence/CountryOfResidenceDropdown';
import { hasDisableNonStopRule } from '../../constants/ruleConstants';
import DriversAge from './DriversAge/DriversAge';

const OptionsRow = () => {
  const bundleType = useSelector(getBundleType);
  const hasDisableNonStop = useConditionalFeature(hasDisableNonStopRule);
  return (
    <div className="row">
      {
        bundleType !== BUNDLE_TYPES.AIR_HOTEL
        && (
          <React.Fragment>
            <CountryOfResidenceDropdown />
            <DriversAge />
          </React.Fragment>
        )
      }
      {
        !hasDisableNonStop
        && (
          <div className="margin-1-b-sm-down margin-3-r-md-up">
            <NonStopCheckbox />
          </div>
        )
      }
    </div>
  );
};

export default OptionsRow;
